import React from 'react';

import Badge from '../../../../../../../components/global/Badge';
import IdentityAvatarContainer from '../../../../../../../containers/global/identity/IdentityAvatarContainer';

const Placeholder = () => {
  return (
    <div className="identity-selector is-loading pointer-events-none">
      <div className="identity-selector-container">
        {Array.from({ length: 3 }).map(index => (
          <div className="identity-selector-avatar" key={index}>
            <IdentityAvatarContainer identity={{}} />
            <Badge badgeSize="xs" round className="text-extra-bold">
              &nbsp;
            </Badge>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Placeholder;
